﻿
import angular from 'angular';

import './cart';
import './discounts';
import './organization';
import './customer-info';
import './confirm';
import '../../services/cart';

angular.module('folkeuni').component('checkout', {
  controller: function (Cart, $rootScope, $scope, $location, $window, $document, debounce) {
    var $ctrl = this;
    $ctrl.cart = {};
    $ctrl.students = [];
    $ctrl.productIds = [];
    $ctrl.usingClerk = false;
    $ctrl.state = {
      loading: true,
      step: null
    };

    $rootScope.$on('$locationChangeSuccess', function (event, newUrl, oldUrl) {
      var locationPath = $location.path();
      var currentPage = locationPath.charAt(locationPath.substring(1)) === '/' ? locationPath.substring(1) : locationPath;
      $document.scrollToElement(document.getElementsByTagName("checkout")[0], 0, 500);
      if (currentPage) {
        $ctrl.state.step = currentPage;
      } else {
        $location.path('cart').replace();
      }
    });

    $ctrl.setStep = function (step) {
      if (step == 1 && ($ctrl.state.step == 'delivery' || $ctrl.state.step == 'discount' || $ctrl.state.step == 'confirm')) {
        $location.path('cart');
      }
      else if (step == 2 && $ctrl.state.step == 'confirm') {
        $location.path('delivery');
      }
    }

    $ctrl.$onInit = function () {
      Cart.read().then(function (successResponse) {
        $ctrl.productIds = successResponse.products.map(item => item.id);
          if (window.Clerk != null) {
            $ctrl.usingClerk = true;
            setTimeout(() => {
              window.Clerk('content', '.clerk-recommendations');
            }, 10);
          }
      }, function (errorResponse) { });
    };

    $rootScope.$on('cart.update', async function (evt, cart) {
      if (!cart.checkout) {
        Cart.customerInfoLocalStorageGet().then((customerInfo) => {
          cart.checkout = JSON.parse(customerInfo);
        }).catch((error) => {});
        if (!cart.checkout && $ctrl.state == "confirm") {
          alert("Der skete en fejl og du stilles videre til din kurv.");

          $location.path('cart');
        }
      }
      $ctrl.cart = cart;
        if (window.Clerk != null) {
          window.Clerk('cart', 'set', $ctrl.cart.products.map(product => product.id));
        }

      $ctrl.state.loading = false;

    });
  },

  templateUrl: '/shop-dist/templates/checkout.html?c=' + window.cacheBurst,
  bindings: {
    siteId: '@',
    currentPageId: '@'
  },
  transclude: {
    cartDescription: "cartDescription",
    customerDescription: "customerDescription",
    paymentDescription: "paymentDescription",
    confirmDescription: "confirmDescription"
  }
});
